export const IMAGES = [
    'assets/img/clients/wah.png',
    'assets/img/clients/ogdcl.png',
    'assets/img/clients/ztbl.png',
    'assets/img/clients/sc.png',
    'assets/img/clients/caa.png',
    'assets/img/clients/pta.png',
    'assets/img/clients/nepra.png',
    'assets/img/clients/nha.png',
    'assets/img/clients/fwo.jpeg',
    'assets/img/clients/rc.jpg',
    'assets/img/clients/metro.png',
    'assets/img/clients/petro.jpg',
    'assets/img/clients/amson.png'
];

export const LAWYER_DETAILS = [
    {
        name: 'Malik Khalid Mehmood Walayet',
        title: 'Founding Partner',
        education: 'LLB University of the Punjab'
    },
    {
        name: 'Malik Saqib Mehmood Khalid (AHC)',
        title: 'Partner',
        education: 'LLB International Islamic University Islamabad'
    },
    {
        name: 'Mr. Muhammad Usama Rauf',
        title: 'Partner',
        education: 'LLB, LLM & Bar at Law UK'
    },
    {
        name: 'Mr. Waqar A. Sheikh (ASC)',
        title: 'Senior Consultant',
        education: 'LLB University of the Punjab'
    },
    {
        name: 'Mr. Nadeem Sheikh (ASC)',
        title: 'Senior Consultant',
        education: 'LLB University of the Punjab'
    },
    {
        name: 'Mr. Mian Abdul Rauf (ASC)',
        title: 'Senior Consultant',
        education: 'LLB University of the Punjab'
    },
    {
        name: 'Mr. Khawar Munir (AHC)',
        title: 'Associate Partner',
        education: 'LLB University of the Punjab'
    },
    {
        name: 'Mrs. Misbah Ashaq (AHC)',
        title: 'Associate Partner',
        education: 'LLB International Islamic University Islamabad, LLM Qatar'
    },
    {
        name: 'Mr. Adil Mehmood Mirza (AHC)',
        title: 'Associate Partner',
        education: 'LLB International Islamic University Islamabad'
    },
    {
        name: 'Miss Saqiba Basharat (AHC)',
        title: 'Associate Partner',
        education: 'LLB (Hons) International Islamic University Islamabad'
    },
    {
        name: 'Mr. Malik Shahzaib (AHC)',
        title: 'Associate Partner',
        education: 'LLB, LLM & Bar at Law UK'
    },
    {
        name: 'Mr. Ali Irtaza (AHC)',
        title: 'Associate Partner',
        education: 'LLB International Islamic University Islamabad'
    }
]